// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__gFTe1","resendInfoText":"OnGoingPaymentBox_resendInfoText__1iQ_i"};